import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreatingStudentUsingCSV.scss';
import bulkStudentsCSVFile from '../../../Assets/excelTemplate/bulkStudentSheet.csv';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import downArrow from '../../../Assets/commonImg/down-dark-arrow.svg';
import NavigateBack from '../../CommonScreens/NavigateBack/NavigateBack';
import { Modal } from '@mui/material';
import { SelectCollegeModal } from '../../../Components/SelectCollegeModal/SelectCollegeModal';
import { SelectCourseModal } from '../../../Components/SelectCourseModal/SelectCourseModal';
import { createBulkStudents } from '../../../Services/StudentService';
import Swal from 'sweetalert2';

function createData(firstName, lastName, email, phoneNumber, dateOfBirth) {
    return { firstName, lastName, email, phoneNumber, dateOfBirth };
}

const rows = [
    createData('Jhon', 'Jhon', 'Jhon@gmail.com', 9967677888, 'MM/DD/YYYY'),
];

export default function CreatingStudentUsingCSV({ sideNavState, setSideNavState }) {

    const initialState = {
        collegeId: "",
        courseId: "",
        startYear: "",
        endYear: "",
        usernamePattern: "",
        countryCode: "91"
    }
    const navigate = useNavigate();


    const [selectedFile, setSelectedFile] = useState(null);
    const [formData, SetFormData] = useState(initialState);
    const [openCollegeModal, setOpenCollegeModal] = useState(false);
    const [openCourseModal, setOpenCourseModal] = useState(false);
    const handleCloseModalCollege = () => setOpenCollegeModal(false);
    const handleCloseModalCourse = () => setOpenCourseModal(false);
    const handleCourseOpen = () => setOpenCourseModal(true);
    const { collegeName = '', courseName = '', collegeId, startYear, endYear, usernamePattern, countryCode } = formData;

    const onStudentPreview = () => {
        if (formData && selectedFile) {
            let type = 'preview';
            createBulkStudents(formData, selectedFile, type)
                .then((studentResponse) => {
                    if (studentResponse.status === 200) {
                        let data = { ...studentResponse.data, collegeName: collegeName, courseName: courseName };
                        navigate('/home/studentPreview', { replace: true, state: { data: data, formData: formData } });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: error.message,
                    })
                });
        }
    }

    const handleFileInputChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleCollegeOpen = () => setOpenCollegeModal(true);

    const setCollegeName = (event) => {
        SetFormData((previousValue) => { return { ...previousValue, ...event } });
    }

    const setCourseName = (event) => {
        SetFormData((previousValue) => { return { ...previousValue, ...event } });
    }

    const onFormValueChange = (e) => {
        const { name, value } = e.target;
        SetFormData({ ...formData, [name]: value });
    }

    return (
        <div className={'student-csv-container ' + (sideNavState ? 'fullWidthOpenSideNav' : 'halfWidthOpenSideNav')}>
            <div className='container-fluid'>
                <div className='row'>
                    <NavigateBack /><br />
                    <div className='student-create-csv-card py-2'>
                        <ul className="timeline">
                            <li className='timeList'>
                                <time className="time"></time>
                                <div className="icon icon-phone">1</div>
                                <div className='row download-the-csv-temp py-3 px-4'>
                                    <div className='download-the-csv-title'>Download the CSV Template</div>
                                    <div className='col-12 mt-1 mb-2 download-csv'>
                                        <a type="button" href={bulkStudentsCSVFile} download="bulkDataSheet.csv"
                                            class="btn btn-light text-primary mt-3"><small><i class="fas fa-download"></i> DOWNLOAD BLANK CSV
                                                TEMPLATE</small></a>
                                    </div>
                                    <div className='download-the-csv-note'><b>Note:</b> You can add upto 200 student in a single CSV file.</div>
                                </div>
                            </li>
                            <li className='timeList'>
                                <time className="time"></time>
                                <div className="icon icon-phone">2</div>
                                <div className='row download-the-csv-temp py-3 px-4 my-4'>
                                    <div className='download-the-csv-title-second'>How to Add user info in CSV template ?</div>
                                    <div className='download-the-csv-sub-title my-2'>*Required fields are first name, last name, email, password</div>
                                    <div className='mb-2'>
                                        <Paper sx={{ width: '100%' }}>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" colSpan={1}>
                                                                A
                                                            </TableCell>
                                                            <TableCell align="center" colSpan={1}>
                                                                B
                                                            </TableCell>
                                                            <TableCell align="center" colSpan={1}>
                                                                C
                                                            </TableCell>
                                                            <TableCell align="center" colSpan={1}>
                                                                D
                                                            </TableCell>
                                                            <TableCell align="center" colSpan={1}>
                                                                E
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow className='table-data-row'>
                                                            <TableCell align="center">First Name</TableCell>
                                                            <TableCell align="center">Last Name</TableCell>
                                                            <TableCell align="center">Email</TableCell>
                                                            <TableCell align="center">Contact No</TableCell>
                                                            <TableCell align="center">Date of Birth</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {rows
                                                            .map((row) => {
                                                                return (
                                                                    <TableRow hover role="checkbox" className='table-data-row' tabIndex={-1} key={row.code}>
                                                                        <TableCell align="center">{row.firstName}</TableCell>
                                                                        <TableCell align="center">{row.lastName}</TableCell>
                                                                        <TableCell align="center">{row.email}</TableCell>
                                                                        <TableCell align="center">{row.phoneNumber}</TableCell>
                                                                        <TableCell align="center">{row.dateOfBirth}</TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </div>
                                </div>
                            </li>
                            <li className='timeList'>
                                <time className="time"></time>
                                <div className="icon icon-phone">3</div>
                                <div className='row download-the-csv-temp py-3 px-4'>
                                    <div className='download-the-csv-title-second'>Upload CSV file & User Details</div>
                                    <div className='p-3 m-3' style={{ background: 'white' }}>
                                        <div className='row mb-2'>
                                            <div className='col-10'>
                                                <div className='row'>
                                                    <div className='col-lg-4 col-12'>
                                                        <p className="input-label mb-0">Select College</p>
                                                        <div className='position-relative' onClick={handleCollegeOpen}>
                                                            <input className="custom-input" type='text' placeholder='select college' readOnly value={collegeName} />
                                                            <div className='down-arrow'> <img src={downArrow} width={'12px'} height={'13px'} alt="^"/></div>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-4 col-12'>
                                                        <p className="input-label mb-0" >Select Course</p>
                                                        <div className="position-relative">
                                                            <input className="custom-input ps-3" type="text" placeholder="Select Course" onClick={handleCourseOpen} readOnly value={courseName} disabled={!collegeId} />
                                                            <div className="down-arrow">
                                                                {" "}
                                                                <img src={downArrow} width={"12px"} height={"13px"} alt='^'/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-4 col-12'>
                                                        <p className="input-label mb-0" >User name Pattern</p>
                                                        <input name="usernamePattern" className='custom-select-input' placeholder='PSGV-' value={usernamePattern} onChange={(event) => {
                                                            onFormValueChange(event);
                                                        }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-2'></div>
                                        </div>
                                        <div className='row mb-2'>
                                            <div className='col-10'>
                                                <div className='row'>
                                                    <div className='col-lg-4 col-12'>
                                                        <p className="input-label mb-0" >Select Country Code</p>
                                                        <div className='position-relative'>
                                                            <select className="custom-select-input" name="countryCode" value={countryCode} onChange={(event) => {
                                                                onFormValueChange(event);
                                                            }}>
                                                                <option value='91'>+91</option>
                                                                <option value='44'>+44</option>
                                                            </select>
                                                            <div className='down-arrow'> <img src={downArrow} width={'12px'} height={'13px'} marginTop={'5px'} alt="^"/></div>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-4 col-12'>
                                                        <p className="input-label mb-0" >Start Year</p>
                                                        <div className='position-relative'>
                                                            <input className='custom-select-input' placeholder='2024' type='number' name="startYear" value={startYear} onChange={(event) => {
                                                                onFormValueChange(event);
                                                            }} />
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-4 col-12'>
                                                        <p className="input-label mb-0" >End Year</p>
                                                        <input className='custom-select-input' placeholder='2028' type='number' name="endYear" value={endYear} onChange={(event) => {
                                                            onFormValueChange(event);
                                                        }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-2'></div>
                                        </div>
                                        <div className='row mt-2 mb-3'>
                                            <div className='add-csv-file'>Add CSV file <input className='input-file' accept=".csv" type='file' onChange={handleFileInputChange} /></div>
                                        </div>
                                        <p className='download-the-csv-note'>Note : Please provide a unique username pattern for your respective student to generate username. The alphanumeric digits after the selected user pattern will be auto-generated by the system. Ex:- MEDSTD001 where MEDSTD will be provided by Institute & the rest will be system generated</p>
                                        <button className='preview-btn' onClick={onStudentPreview}>Preview</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Modal open={openCollegeModal} onClose={handleCloseModalCollege}>
                <div>
                    <SelectCollegeModal {...{ handleClose: handleCloseModalCollege, setCollegeName }} />
                </div>
            </Modal>
            <Modal open={openCourseModal} onClose={handleCloseModalCourse}>
                <div>
                    <SelectCourseModal {...{ handleCourseClose: handleCloseModalCourse, setCourseName, collegeId }} />
                </div>
            </Modal>
        </div>
    )
}
